import type { ErroDaSimulacao, UnidadeDeAvanco, ValidacaoDoAvanco } from '../types';

/**
 * 5xx com `comandoId`: o core fechou o comando como FALHOU depois do CAS do relógio (no avanço, só
 * o processamento dos vencidos lança; o CAS e o lock falham com 409). O tempo já andou, então
 * repetir o avanço somaria de novo: a continuação vai por POST /vencimentos.
 */
export const avancoFalhouDepoisDeAndar = (erro: ErroDaSimulacao | null): boolean =>
  erro !== null && erro.comandoId !== null && erro.status >= 500;

/** LIMITE_AVANCO_RELOGIO_MINUTOS do core (CA-16): 30 dias por avanço, igual à guarda. */
const LIMITE_DO_AVANCO_EM_MINUTOS = 43_200;

const MINUTOS_POR_UNIDADE: Record<UnidadeDeAvanco, number> = {
  MINUTOS: 1,
  HORAS: 60,
  DIAS: 1_440,
};

export const UNIDADES_DE_AVANCO: UnidadeDeAvanco[] = ['MINUTOS', 'HORAS', 'DIAS'];

export const ehUnidadeDeAvanco = (valor: string): valor is UnidadeDeAvanco =>
  UNIDADES_DE_AVANCO.some((unidade) => unidade === valor);

const INTEIRO_POSITIVO = /^\d+$/u;

/**
 * Mesma regra do avancoRelogioSchema do core (CA-15): inteiro ≥ 1 e até 43.200 minutos na unidade
 * escolhida. Recusar aqui evita o 400 AVANCO_INVALIDO e não toca no relógio. Campo vazio não
 * mostra mensagem: a pessoa ainda está digitando.
 */
export const validarAvanco = (quantidade: string, unidade: UnidadeDeAvanco): ValidacaoDoAvanco => {
  const texto = quantidade.trim();
  if (!texto) return { valido: false, mensagem: null };
  if (!INTEIRO_POSITIVO.test(texto) || Number(texto) < 1) {
    return { valido: false, mensagem: 'Informe um número inteiro maior que zero.' };
  }
  const numero = Number(texto);
  if (numero * MINUTOS_POR_UNIDADE[unidade] > LIMITE_DO_AVANCO_EM_MINUTOS) {
    return { valido: false, mensagem: 'Cada avanço vai até 30 dias.' };
  }
  return { valido: true, avanco: { quantidade: numero, unidade } };
};
